/**
 * <s-wishlist-heart> — toggles one product in the wishlist.
 * Product details come from data-* attributes written by snippets/wishlist-heart.liquid.
 */
import { has, add, remove, refresh, onChange } from '@theme/wishlist-store';

class SWishlistHeart extends HTMLElement {
  #ac;

  connectedCallback() {
    this.#ac = new AbortController();
    const { signal } = this.#ac;
    this.button = this.querySelector('button');
    if (!this.button) return;
    this.#sync();

    this.button.addEventListener('click', (event) => {
      event.preventDefault();
      event.stopPropagation();
      const d = this.dataset;
      if (has(d.handle)) {
        remove(d.handle);
      } else {
        add(this.#details());
      }
    }, { signal });

    // Keep already-saved items current (price, sale price, image) whenever the product is shown.
    if (has(this.dataset.handle)) refresh(this.#details());

    onChange(() => this.#sync(), signal);
  }

  disconnectedCallback() {
    this.#ac?.abort();
  }

  #details() {
    const d = this.dataset;
    return { id: d.id, handle: d.handle, title: d.title, url: d.url, image: d.image, price: d.price, compare: d.compare || '', amount: Number(d.amount) || 0 };
  }

  #sync() {
    const saved = has(this.dataset.handle);
    this.button.setAttribute('aria-pressed', String(saved));
    this.toggleAttribute('data-saved', saved);
  }
}

if (!customElements.get('s-wishlist-heart')) customElements.define('s-wishlist-heart', SWishlistHeart);
